// extracted by mini-css-extract-plugin
export var fadeIn = "_ib-1";
export var modalContent = "_ib-3";
export var overlay = "_ib-0";
export var popoverContent = "_ib-2";
export var results = "_ib-5";
export var searchInputWrapper = "_ib-4";